/**
 * 双位数字 小于10补0
 */
export const twodigit = val => {
  return `0${val}`.slice(-2)
}

/**
 * 日期格式化
 */
export const dateFormat = (date, format) => {
  let formatStr = format || 'yyyy-MM-dd HH:mm:ss'
  date = new Date(date) || new Date()
  if (typeof date === 'string') {
    formatStr = date
    date = new Date()
  }
  var str = formatStr
  str = str.replace(/yyyy|YYYY/, date.getFullYear())
  str = str.replace(
    /yy|YY/,
    date.getYear() % 100 > 9
      ? (date.getYear() % 100).toString()
      : '0' + date.getYear() % 100
  )
  str = str.replace(/MM/, twodigit(date.getMonth() + 1))
  str = str.replace(/M/g, date.getMonth() + 1)
  str = str.replace(/dd|DD/, twodigit(date.getDate()))
  str = str.replace(/d|D/g, date.getDate())
  str = str.replace(/hh|HH/, twodigit(date.getHours()))
  str = str.replace(/h|H/g, date.getHours())
  str = str.replace(/mm/, twodigit(date.getMinutes()))
  str = str.replace(/m/g, date.getMinutes())
  str = str.replace(/ss|SS/, twodigit(date.getSeconds()))
  str = str.replace(/s|S/g, date.getSeconds())
  return str
}

export const dateISO = (date) => {
  return new Date(date).toISOString().substring(0, 19) + 'Z'
}

/**
 * 手机号码验证
 */
export const isMobile = it => {
  // return /^0?(13[0-9]|14[456789]|15[012356789]|16[0678]|17[0-9]|18[0-9]|19[89])[0-9]{8}$/.test(it)
  return /^\d{2,}$/.test(it)
}

/**
 * 短信验证码验证
 */
export const isSmsCode = it => {
  return /\d{6}/.test(it)
}

/**
 * 绑定手机号短信验证码验证
 */
export const isSmsPhoneBindCode = it => {
  return /\d{4}/.test(it)
}

/**
 * 银行验证
 */
export const isBank = it => {
  return /^([1-9]{1})(\d{15}|\d{18})$/.test(it)
}

/**
 * 身份验证
 */
export const isCard = it => {
  return /(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(it)
}

/**
 * 字符串转数组
 */
export const strChangeArr = (str) => {
  if (str === null || str === '') {
    str = '正常，正常'
  }
  var strArr = str.split(',')
  return strArr
}
